import React, { useEffect } from "react";
import { Form } from "antd";
import DrawerDetails from "../../shared/components/DrawerDetails";
import ClientForm from "./ClientForm";
import { useCreateClient } from "../hooks/useCreateClient";
import type { ClientData } from "../types";
import openNotification from "../../../utils/openNotification";

interface ClientFormDrawerProps {
  open: boolean;
  onClose: () => void;
  /**
   * Se llama con el id del cliente recién creado. Para entonces la lista de
   * clientes (query `clients`) ya fue refrescada, así que el nuevo cliente
   * puede seleccionarse de inmediato en cualquier Select.
   */
  onCreated?: (id_client: number, client: ClientData) => void;
  title?: string;
  formId?: string;
}

/**
 * Alta rápida de un cliente sin salir de la pantalla actual: reutiliza el
 * mismo ClientForm del catálogo dentro de un Drawer.
 */
const ClientFormDrawer: React.FC<ClientFormDrawerProps> = ({
  open,
  onClose,
  onCreated,
  title = "Nuevo Cliente",
  formId = "quick-client-form",
}) => {
  const [form] = Form.useForm<ClientData>();
  const { mutate: createClientMutation, isPending } = useCreateClient();

  useEffect(() => {
    if (open) form.resetFields();
  }, [open, form]);

  const handleFinish = (values: ClientData) => {
    createClientMutation(values, {
      onSuccess: (res) => {
        openNotification("success", "Cliente creado exitosamente");
        const id_client = res.data?.id;
        if (id_client) onCreated?.(id_client, { ...values, id_client });
        form.resetFields();
        onClose();
      },
      onError: (error) => {
        openNotification("error", "Error", error.message);
      },
    });
  };

  return (
    <DrawerDetails
      title={title}
      open={open}
      onClose={onClose}
      contentBody={
        <div style={{ maxWidth: 640, margin: "0 auto" }}>
          <ClientForm
            form={form}
            onFinish={handleFinish}
            isPending={isPending}
            buttonText="Guardar Cliente"
            formId={formId}
          />
        </div>
      }
    />
  );
};

export default ClientFormDrawer;
